import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {Router} from '@angular/router';
import {FrontDeskService} from 'src/app/services/front-desk.service';
import {MemberService} from 'src/app/services/member.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';
import {FrontDeskRegisterConfirmComponent} from '../front-desk-register-confirm/front-desk-register-confirm.component';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk-register',
  templateUrl: './front-desk-register.component.html',
  styleUrls: [ './front-desk-register.component.scss' ]
})
export class FrontDeskRegisterComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public memberForm: FormGroup;
  public subCategories: any[] = []
  public subCategorySelected: any = {};
  public spinner: boolean = false;

  constructor (
    public _frontDeskService: FrontDeskService,
    private _memberService: MemberService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private router: Router

  ) {

    this.loadSubCategories()
    this.memberForm = this._frontDeskService.createMemberForm()
  }

  ngOnInit () {

  }


  registerMember () {

    if (this.memberForm.valid) {
      this.spinner = true

      let data = this.memberForm.getRawValue()

      let newMember: any = {}
      newMember.name = data.name.trim();
      newMember.shortName = data.shortName.trim();
      newMember.email = data.email.trim();
      newMember.cellPhone = data.cellPhone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")
        .trim()
      newMember.cpf = data.cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .trim()
      newMember.crm = data.crm.trim()

      newMember.subCategory = this.subCategorySelected

      newMember.situation = '0'
      newMember.balance = 0
      newMember.annuity_from = 0

      delete newMember.subCategory.documents
      delete newMember.subCategory.documents_en

      // console.log(JSON.stringify(newMember))

      this._memberService.selectByDocNumber(newMember.cpf)
        .subscribe((docResult) => {

          if (!docResult.empty) {
            this.spinner = false;

            this.dialog.open(AlertComponent, {
              width: '450px',
              height: '300px',
              panelClass: 'custom-dialog-container',
              data: {title: "Alerta", message: "O documento: <br><br>" + newMember.cpf + "<br><br>" + "já está registrado."}
            });

          } else {
            this.spinner = false;

            console.log(JSON.stringify(newMember))


            let dialogRef = this.dialog.open(FrontDeskRegisterConfirmComponent, {
              width: '500px',
              height: '460px',
              panelClass: 'custom-dialog-container',
              data: newMember
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result == "ok") {
                
                this._memberService.insert(newMember)
                  .then((result) => {
                    newMember.id = result.id
                    this._frontDeskService.currentMember = newMember
                    this.snackBar.openSnackBar("Sucesso!", '', 'success');
                    this.router.navigate([ 'front-desk-orders' ]);
                  })
                  .catch(() => {
                    this.snackBar.openSnackBar("Erro!", '', 'error');
                  })
                  .finally(() => {
                    this.spinner = false;
                  })

              }
            })
          }
        })
    }

  }

  subCategorySelectedChange (id) {

    this.subCategorySelected = this.subCategories.find((e) => {
      return e.id == id
    })

    // console.log(JSON.stringify(this.subCategorySelected))
  }

  loadSubCategories () {

    // this.subCategories = this._frontDeskService.selectSubcategoriesFrontDesk()

    //this._subcategoryService.selectSubcategories(true)


    this._frontDeskService.selectSubcategoriesFrontDeskDb()
      .subscribe((result) => {
        result.forEach((item) => {

          this.subCategories.push({
            'id': item.id,
            'name': item.data().name,
            'documents': item.data().documents,
            'documents_en': item.data().documents_en,
            'hidden': item.data().hidden,
            'partner': item.data().partner
          })

        })



      })

  }

  goBack () {
    this.router.navigate([ 'front-desk' ]);
  }
}
